import React, { useEffect } from "react";

interface ConversationGiftProps {
  stickerId?: number;
  stickerImageUrl?: string | null;
}

//TODO: Remove this after finishing development
const giftStyle: React.CSSProperties = {
  position: "absolute",
  left: "15px",
  bottom: "10px",
  backgroundColor: "#ff0047",
  width: "50px",
  textAlign: "center",
  color: "#f7e5e5",
};

const ConversationGift = ({
  stickerId,
  stickerImageUrl,
}: ConversationGiftProps) => {
  // return <div style={giftStyle}>{stickerId}</div>;

  return (
    <>
      {stickerImageUrl && (
        <img
          src={stickerImageUrl}
          loading="lazy"
          alt=""
          className="message_gift"
        ></img>
      )}
    </>
  );
};

export default ConversationGift;
